import { Endpoint } from "../data";

export default [
    {
        protocol: 'https',
        name: 'Paychex CDN',
        base: 'cdn.paychexinc.com',
        path: '/ent/png/landing_static/html',
        success: 418
    }
] as Endpoint[]